import { initializeApp } from "firebase/app";
import {
  getAuth,
  signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut, onAuthStateChanged,
  sendEmailVerification, sendPasswordResetEmail
} from "firebase/auth";
import { 
  initializeFirestore,
  persistentLocalCache
} from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBO3-hAhKPyUm3HguNf8SPE3Hjr_wEALhU",
  authDomain: "camperros-rutas.firebaseapp.com",
  projectId: "camperros-rutas",
  storageBucket: "camperros-rutas.firebasestorage.app",
  messagingSenderId: "642970946255",
  appId: "1:642970946255:web:c64446a44573a1278f85ba"
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache(),
  experimentalAutoDetectLongPolling: true,
  useFetchStreams: false
});
export const storage = getStorage(app);

// NOTE: Auth persistence is initialized separately in src/lib/auth.js
// to avoid race conditions and ensure proper fallback behavior.
// See: initializeAuthPersistence(auth) in src/lib/auth.js

export { signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut, onAuthStateChanged, sendEmailVerification, sendPasswordResetEmail };
